import type { MapStatus } from "@/api/types";

/** A remap's suggested reason, from a map's status: what its latest relevance check found
 * would help, else what it references that changed, else — for a map made before maps
 * suggested tools — that. The Map page prefills its Reason field with it. */
export function suggestedReason(s: MapStatus): string {
  const helps = s.check?.up_to_date ? s.check.helps : [];
  if (helps.length > 0)
    return helps.map((h) => `${h.name}${h.ring ? ` (${h.ring})` : ""} may help: ${h.reason}`).join("; ");
  const changed = s.stale.map((g) => `${g.changed.map((c) => c.name).join(", ")} changed`).join("; ");
  return changed || (s.predates_suggestions ? "To add tool and practice suggestions" : "");
}
